import { render, staticRenderFns } from "./ScholarshipHeader.vue?vue&type=template&id=25459606&scoped=true&"
import script from "./ScholarshipHeader.vue?vue&type=script&lang=js&"
export * from "./ScholarshipHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipHeader.vue?vue&type=style&index=0&id=25459606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25459606",
  null
  
)

export default component.exports